import React from "react";
import styled from "styled-components";
import Lottie from "lottie-react";
import unauthorizedAnimation from "../assets/animations/unauthorized-animation.json"; // You'll need to download a suitable Lottie animation

const UnauthorizedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
`;

const ContentWrapper = styled.div`
  text-align: center;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
  backdrop-filter: blur(4px);
`;

const Title = styled.h1`
  color: #2c3e50;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  color: #7f8c8d;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const AnimationWrapper = styled.div`
  width: 300px;
  height: 300px;
  margin: 0 auto 2rem;
`;

const Button = styled.button`
  background: linear-gradient(45deg, #2196F3, #1976D2);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Unauthorized = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <UnauthorizedContainer>
      <ContentWrapper>
        <AnimationWrapper>
          <Lottie
            animationData={unauthorizedAnimation}
            loop={true}
            autoplay={true}
          />
        </AnimationWrapper>
        <Title>403 - Access Denied</Title>
        <Subtitle>
          Sorry, you don't have permission to access this page.
          Please contact your administrator if you believe this is a mistake.
        </Subtitle>
        <Button onClick={handleGoBack}>
          Go Back
        </Button>
      </ContentWrapper>
    </UnauthorizedContainer>
  );
};

export default Unauthorized;